// extracted by mini-css-extract-plugin
export var list = "related-list-module--list--0794b";
export var wrapper = "related-list-module--wrapper--27cc2";